import { RouteConfig } from "vue-router";

export const commonRouters: RouteConfig[] = [];

commonRouters.push({
  path: "/about",
  name: "about",
  component: () =>
    import(/* webpackChunkName: "commonAbout" */ "@/views/About.vue"),
});

commonRouters.push({
  path: "/register",
  name: "registerPage",
  component: () =>
    import(
      /* webpackChunkName: "commonRegister" */ "@/views/common/RegisterPage.vue"
    ),
  meta: { name: "注册页面", auth: true },
});

commonRouters.push({
  path: "/bindUser",
  name: "bindUserPage",
  component: () =>
    import(
      /* webpackChunkName: "commonRegister" */ "@/views/common/BindUserPage.vue"
    ),
  meta: { name: "绑定页面", auth: true },
});

commonRouters.push({
  path: "/clearCache",
  name: "clearCachePage",
  component: () =>
    import(
      /* webpackChunkName: "commonRegister" */ "@/views/common/ClearCachePage.vue"
    ),
  meta: { name: "清除缓存" },
});
